const TmpA004 = (page, section) => {
  const media = [];
  const images = [];
  const modifiedPage = {
    ...page
  };
  const image = {
    size: '900px X 900px',
    ...page.content.media,
    page: page.id,
    src: page.label.toLowerCase().replaceAll('-', '_') + '.jpg'
  };
  // add the media object to the media array
  media.push(image);
  images.push(image);
  // add the image reference to the modified page
  modifiedPage.content.media.src = image.src;

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpA004;
